module.exports = __webpack_public_path__ + "static/img/risk_scan.f40774c9.png";